export default __webpack_public_path__ + "static/media/mod04.36aba39b.svg";